import React, { useMemo } from 'react';
import { SidebarPortal } from '@plone/volto/components';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import HeadlineWithBubblesView from './HeadlineWithBubblesView';
import HeadlineWithBubblesSchema from './schema';

const Edit = (props) => {
  const schema = useMemo(() => HeadlineWithBubblesSchema(props), [props]);

  return (
    <>
      <HeadlineWithBubblesView {...props} mode="edit" />
      <SidebarPortal selected={props.selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          onChangeBlock={props.onChangeBlock}
          formData={props.data}
          block={props.block}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
